import React from 'react';

import classNames from 'classnames';

import Dropdown from './index';

import './styles.scss';

interface Props {
  children?: React.ReactNode;
  className?: string;
  disabled?: boolean;
  icon?: React.ReactNode;
  label?: string;
}

// Dropdowns and sticky cells don't play nice by default
// This combines the two with some preset props/overrides to make them nicer
// Always styled as sticky, but that seems to play nice even in non-sticky tables
//
// `portal` renders the menu into document.body so it isn't clipped by the
// table's `overflow: auto` + `border-radius` wrapper. Without it, Safari cuts
// off the menu options and forces users to scroll inside the table to reach them.
export default function DropdownCell({ children, className, disabled, icon, label, ...props }: Props) {
  return (
    <td
      className={classNames('dropdown__cell dropdown__cell--sticky sticky-cell end-cell', className)}
      {...props}
    >
      <Dropdown
        align="start"
        disabled={disabled}
        drop="start"
        icon={icon}
        label={label}
        portal
      >
        {children}
      </Dropdown>
    </td>
  );
}
